<template>
  <a-modal :visible="visible" :title="title" :footer="null" :afterClose="afterClose" :width="600"
    @cancel="$emit('cancel')" :maskClosable="false">
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
      <a-form-item label="地块名称">
        <a-input v-decorator="['areaName', { rules: [{ required: true, message: '请输入地块名称' }] }]" />
      </a-form-item>
      <template v-if="areaLevel >= 1">
        <a-form-item label="地块标题">
          <a-input v-decorator="['areaTitle']" />
        </a-form-item>
        <a-form-item label="简介">
          <a-textarea v-decorator="['areaBrief']" placeholder="" allow-clear :auto-size="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
        <!-- areaImg -->
        <a-form-item label="上传图片">
          <a-upload
            name="file"
            :multiple="false"
            :action="$api.uploadUrl"
            list-type="picture"
            :headers="headers"
            :data="otherParams"
            @change="(e) => handleChange(e)"
            :before-upload="beforeUpload"
            :file-list="fileList"
          >
            <a-button> <a-icon type="upload" /> 上传图片 </a-button>
          </a-upload>
        </a-form-item>
      </template>
      <template v-if="areaLevel >= 2">
        <a-form-item label="监控链接">
          <a-input v-decorator="['monitorLink']" />
        </a-form-item>
        <a-form-item label="价格">
          <a-input-number v-decorator="['price']" :min="0" />
        </a-form-item>
      </template>
      <template v-if="areaLevel >= 3">
        <a-form-item label="种植面积">
          <a-input-number v-decorator="['plotSize']" :min="0" :precision="0" />
          <span style="margin-left: 10px;">m²</span>
        </a-form-item>
        <a-form-item label="配送次数">
          <a-input-number v-decorator="['deliveryCount']" :min="0" :precision="0" />
        </a-form-item>
        <a-form-item label="有效期年数（年）">
          <a-input-number v-decorator="['effectYear']" :min="0" :precision="0" />
        </a-form-item>
      </template>
      <!-- <a-form-item label="地块详情">
        <a-textarea placeholder="" allow-clear :auto-size="{ minRows: 2, maxRows: 6 }" v-decorator="['desc']" />
      </a-form-item>
      <a-form-item label="是否认购">
        <a-switch v-decorator="['purchased', { valuePropName: 'checked', initialValue: false }]" @change="switchChange" />
      </a-form-item>
      <template v-if="purchased">
        <a-form-item label="认购人">
          <a-input v-decorator="['person', { rules: [{ required: purchased, message: '请输入' }] }]" />
        </a-form-item>
        <a-form-item label="到期时间">
          <a-date-picker v-decorator="['deadline', { rules: [{ required: purchased, message: '请选择时间'}]}]" />
        </a-form-item>
      </template> -->
      <a-form-item :wrapper-col="{ span: 12, offset: 7 }">
        <a-button type="primary" html-type="submit" style="margin-right: 20px;">确认</a-button>
        <a-button @click="toLower" v-if="hasBtn" style="margin-right: 20px;">前往</a-button>
        <a-button @click="dele" type="danger" v-if="hasBtn">删除</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>

const token = localStorage.getItem('token')
import _ from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 父级地块的级别
    areaLevel: {
      type: Number,
      default: 0
    },
    hasBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      purchased: false,
      headers: {
        'Authorization': token
      },
      otherParams: {
        name: ''
      },
      fileList: []
    }
  },
  mounted() {
    
  },
  computed: {
    title() {
      var level = ''
      switch(this.areaLevel) {
        case 1: level = '二级';break;
        case 2: level = '三级';break;
        case 3: level = '四级';break;
      }
      return level + '地块'
    }
  },
  methods: {
    // modal confirm
    initForm(formValue) {
      var columns = ['areaName']
      if(this.areaLevel >= 1) {
        columns = columns.concat(['areaTitle', 'areaBrief'])
      }
      if(this.areaLevel >= 2) {
        columns = columns.concat(['monitorLink', 'price'])
      }
      if(this.areaLevel >= 3) {
        columns = columns.concat(['plotSize', 'deliveryCount', 'effectYear'])
      }
      console.log('init', formValue, columns)
      if(formValue.areaImg) {
        this.fileList = [
          {
            url: formValue.areaImg,
            uid: '-1',
            name: 'image.png',
            status: 'done'
          }
        ]
      }
      this.form.setFieldsValue(_.pick(formValue, columns))
      // if(formValue.purchased) {
      //   this.purchased = true
      //   this.$nextTick(() => {
      //     this.form.setFieldsValue(formValue)
      //   })
      // } else {
      // }
    },
    beforeUpload(file) {
      this.otherParams.name = file.name
      return true;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          // console.log('submit', this.fileList)
          if(this.fileList.length > 0) {
            values.areaImg = this.fileList[0].url
          }
          if(values.deadline) {
            values.deadline = values.deadline.format('YYYY-MM-DD')
          }
          // if(values.effectYear) {
          //   values.effectYear = values.effectYear.format('YYYY-MM-DD')
          // }
          this.$emit('submit', values)
        }
      });
    },
    switchChange(checked, event) {
      this.purchased = checked
    },
    toLower() {
      this.$emit('to-lower')
    },
    dele() {
      this.$emit('delete')
    },
    afterClose() {
      this.fileList = []
      this.form.resetFields()
    },
    handleChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      
      fileList = fileList.map(file => {
        if (file.response && file.response.path) {
          var path = file.response.path
          var index = path.indexOf('/file')
          path = 'https://vr.gdyfpt.com' + path.slice(index)
          // path = baseURL + path.slice(index)
          file.url = path
        }
        return file;
      });

      this.fileList = fileList
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// LandDetail.vue?633d9902